import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ILanguage } from '../../interfaces/ILanguage';

const apiUrl = Globals.apiPath + '/languages';

export default class LanguagesService {
  constructor() {}

  async getAll(): Promise<ILanguage[]> {
    let res = await axios.get<ILanguage[]>(`${apiUrl}`);
    return res.data;
  }
}
